import * as mime from 'react-native-mime-types';

export function getMimeTypesForExtension(extension) {
    let result = [mime.lookup(extension)];
    switch (extension) {
        case '.csv':
            result.push('text/plain');
            result.push('application/vnd.ms-excel');
            break;
        default:
            break;
    }
    return result;
}

export function fileExtensionsToAccept(acceptedExtensions) {
    let result = { '': acceptedExtensions };
    acceptedExtensions.forEach(extension => {
        let mimeTypes = getMimeTypesForExtension(extension);
        mimeTypes.forEach(type => {
            if (!Object.keys(result).includes(type)) {
                result[type] = [];
            }
            result[type].indexOf(extension) === -1 && result[type].push(extension);
        });
    });
    return result;
}
